export const toSafeNumber = (value: number | null | undefined): number =>
  value ?? 0;

export const toSafeString = (value: string | null | undefined): string =>
  value ?? "";
